query childCompanies {
    childCompanies {
        id
        name
    }
}
